module.exports = __webpack_public_path__ + "static/media/company-logo.5edb930e.png";